import React from 'react'
import { useEffect, useState, useRef, useLayoutEffect } from 'react';
import './FaultFirstPageCustom.css';
import * as $ from 'jquery';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import NoData from '../../Driveanalysis/NoData';
import WaterMark from '../../DashboardMain/WaterMark';
import BuketsTable from '../../Driveanalysis/BuketsTable';

export default function COmpBiDirTest(props) {
  const [filteredData, SetfilteredData] = useState([]);

  useEffect(() => {
    let dataO = props.dataMain;
    let root = am5.Root.new(props.id);
    root.setThemes([
      am5themes_Animated.new(root)
    ]);

    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        layout: root.verticalLayout,
        arrangeTooltips: false,
      })
    );

    chart.getNumberFormatter().set("numberFormat", "#.#s'%");

    let yAxis = chart.yAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "age",
        renderer: am5xy.AxisRendererY.new(root, {
          inversed: true,
          cellStartLocation: 0.1,
          cellEndLocation: 0.9,
          minGridDistance: 1,
        })
      })
    );

    yAxis.data.setAll(dataO);
    yAxis.get("renderer").grid.template.set("forceHidden", true);

    let xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererX.new(root, {
          strokeOpacity: 0.1,
        })
      })
    );

    xAxis.get("renderer").grid.template.set("forceHidden", true);
    chart.zoomOutButton.set("forceHidden", true);

    function createSeries(field, labelCenterX, pointerOrientation, rangeValue, colSanku, orgLeval, levalLable) {
      let series = chart.series.push(
        am5xy.ColumnSeries.new(root, {
          fill: am5.color(colSanku),
          stroke: am5.color(colSanku),
          xAxis: xAxis,
          yAxis: yAxis,
          valueXField: field,
          categoryYField: "age",
          // valueYField: tipSanku,//
          categoryXField: orgLeval,//
          sequencedInterpolation: true,
          clustered: false,
          tooltip: am5.Tooltip.new(root, {
            // getFillFromSprite: false,
            pointerOrientation: pointerOrientation,
            labelText: levalLable + ": {categoryX}",
            // oversizedBehavior: "fit",
          }),
        })
      );

      series.columns.template.setAll({
        height: am5.p100,
        strokeOpacity: 0,
        fillOpacity: 0.8,
      });

      series.bullets.push(function () {
        return am5.Bullet.new(root, {
          sprite: am5.Label.new(root, {
            centerY: am5.p50,
            text: "{valueX}",
            populateText: true,
            centerX: labelCenterX,
          })
        });
      });

      // code for label hover
      var yRenderer1 = yAxis.get("renderer");

      yRenderer1.labels.template.setAll({
        tooltipText: "[fontSize: 12px]Description: {signal_desc}[/]\n[fontSize: 12px]Value: {signal_val}",
        fontSize: 12,
        fill: am5.color("#000000"),
        oversizedBehavior: "fit",
      });

      yRenderer1.labels.template.setup = function (target) {
        target.set("background", am5.Rectangle.new(root, {
          fill: am5.color("#5d9eab"),
          fillOpacity: 0,
        }));
      };
      // code for label hover

      series.data.setAll(dataO);
      series.appear();

      let rangeDataItem = xAxis.makeDataItem({
        value: rangeValue
      });

      xAxis.createAxisRange(rangeDataItem);
      rangeDataItem.get("grid").setAll({
        strokeOpacity: 1,
        stroke: series.get("stroke")
      });

      let cellSize = 20;
      series.events.on("datavalidated", function (ev) {

        let series = ev.target;
        let chart = series.chart;
        let xAxis = chart.xAxes.getIndex(0);

        // Calculate how we need to adjust chart height
        let chartHeight = series.data.length * cellSize + xAxis.height() + chart.get("paddingTop", 0) + chart.get("paddingBottom", 10);

        // Set it on chart's container
        chart.root.dom.style.height = chartHeight + "px";
      });
      return series;
    }

    createSeries("male", am5.p100, "right", 0, "#ffa344", "orgLevalMale", "Duration (mins)", "signal_nm", "signal_desc", "signal_val");
    createSeries("female", 0, "left", 0, "#358696", "orgLevalFemale", "Vehicle Count", "signal_nm", "signal_desc", "signal_val");

    var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
      // behavior: "zoomY"
      behavior: "none"
    }));
    cursor.lineY.set("forceHidden", true);
    cursor.lineX.set("forceHidden", true);

    chart.appear(1000, 100);
    root._logo.dispose();
    return () => root.dispose();
  }, [props]);

  return (
    <>
      <WaterMark />
      <div id={props.id} style={{ height: "400px" }}></div>
      <div className="modal fade" id={"exampleModal__"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Data</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                  <tr>
                    <th scope="col">Time Duration</th>
                    <th scope="col">Vehicle Count</th>
                  </tr></thead>
                <tbody>
                  <tr>
                    <td scope="col">{filteredData.orgLevalMale}</td>
                    <td scope="col">{filteredData.orgLevalFemale}</td>
                  </tr>
                  <tr>
                    <td scope="col">{filteredData.male}</td>
                    <td scope="col">{filteredData.female}</td>
                  </tr>
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
